import React, { useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { Box, Card, IconButton } from "@mui/material";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import FavoriteIcon from "@mui/icons-material/Favorite";

import FavoritePopover from "src/views/menu/components/make_menu/Popover_make_menu";
import FoodCardContent from "./FoodCardContent";
import FoodCardActions from "./FoodCardAction";
import MenuDialogs from "./MenuCardDialog";
import { addItem } from "src/redux/slices/cartSlice";
import {
  setMenuName,
  openConfirmDeleteDialog,
  closeConfirmDeleteDialog,
} from "src/redux/slices/menuSlice";
import useMenuActions from "../../menu_utilities/menuOperation";
import { foodImageSource } from "src/config/foodImage";

import itemImageFallback from "src/assets/categories/snacks.webp";

function FoodCard({
  fooditem,
  quantity,
  handleIncrement,
  handleDecrement,
  menuName,
  confirmDeleteDialog,
  handleClose,
  handleAddMenu,
  handleMenuClick,
  handleOpenDelete,
  handleMenuDelete,
  handleDeleteDialog,
  items,
  inMenu,
  image,
  showFavorite = true,
  fullWidth = false,
  handleOpenPopover,
  handleClosePopover,
}) {
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const anchorElRef = useRef(null);

  const {
    openPopover,
    popoverID,
    foodItemToAdd,
    selectedMenus,
    openMenuDialog,
    // anchorElId,
    openItemDelete,
    deleteMenuName,
  } = useSelector((state) => state.menus);

  const {
    handleOpenMenuNameDialog,
    handleCloseMenuNameDialog,
    handleSaveMenuName,
    handleInputChange,
    handleOpenItemDeleteDialog,
    handleDeleteItem,
    handleOpenMenuDeleteDialog,
    handleCloseMenuDeleteDialog,
    handleAddItemToExistingMenu,
  } = useMenuActions();

  const getCurrentPrice = () => {
    const hour = new Date().getHours();
    const isDay = hour >= 6 && hour < 18;
    let prices = [];
    if (!fooditem.item_price) return 0;
    try {
      prices = JSON.parse(fooditem.item_price);
    } catch (e) {
      console.error("Error parsing item_price:", e);
      return 0;
    }
    if (prices.length > 1) return isDay ? prices[0] : prices[1];
    if (prices.length === 1) return prices[0];
    return 0;
  };

  const price = getCurrentPrice();
  const imageUrl = foodImageSource(image || fooditem.item_image, fooditem.mimeType) || itemImageFallback;

  const handleAddToCart = () => {
    const concatenatedSubcategory = [
      fooditem.item_subcategory,
      fooditem.item_type,
      fooditem.item_name,
    ]
      .filter(Boolean)
      .join(" ")
      .trim();

    const itemPrice = parseFloat(price);
    if (isNaN(itemPrice)) {
      toast.error("Invalid price. Please try again.");
      return;
    }

    dispatch(
      addItem({
        id: fooditem.item_id,
        subcategory: concatenatedSubcategory,
        price: itemPrice,
        quantity: 1,
        image: imageUrl,
        detail: fooditem.item_description,
      }),
    );
    toast.success(`${concatenatedSubcategory} added to cart!`);
  };

  const handleClickFavorite = (event) => {
    if (handleOpenPopover) handleOpenPopover(event, fooditem);
  };
  // const handleCardNavigate = () => {
  //   navigate("/description", {
  //     state: {
  //       foodItem: {
  //         ...fooditem,
  //         image: base64Image,
  //         price,
  //       },
  //       subcategory:
  //         `${fooditem.item_subcategory} ${fooditem.item_type}`.trim(),
  //     },
  //   });
  // };

  return (
    <Box sx={{ position: "relative" }}>
      <Card
        // onClick={handleCardNavigate}
        sx={{
          width: fullWidth ? "100%" : { xs: 150, sm: 180, md: 180 },
          position: "relative",
          borderRadius: "1.25rem",
          margin: fullWidth ? "1.5rem auto 0.7rem" : "4rem auto 0.7rem",
          textAlign: "center",
          display: "flex",
          // cursor: "pointer",
          flexDirection: "column",
          alignItems: "center",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          overflow: "visible",
          background: "#fffdf7",
          border: "1px solid #e2dfcf",
          boxShadow: "0 6px 20px rgba(65, 70, 39, 0.08)",
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 10px 26px rgba(65, 70, 39, 0.13)",
          },
          "@media (prefers-reduced-motion: reduce)": {
            transition: "none",
            "&:hover": { transform: "none" },
          },
        }}
      >
        {inMenu ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "0.2rem",
              justifyContent: "center",
            }}
          >
            <FoodCardActions
              quantity={quantity}
              handleIncrement={handleIncrement}
              handleDecrement={handleDecrement}
              handleDeleteItem={() => handleDeleteItem(menuName, fooditem.id)}
              handleOpenItemDeleteDialog={(e) =>
                handleOpenItemDeleteDialog(e, menuName, fooditem)
              }
              items={items}
              menuName={menuName}
              openItemDelete={openItemDelete}
              fooditem={fooditem}
            />
          </Box>
        ) : showFavorite ? (
          <IconButton
            ref={anchorElRef}
            id={`favorite-icon-${fooditem.id}`}
            size="small"
            sx={{
              position: "absolute",
              top: 3,
              left: 3,
              zIndex: 10,
              backgroundColor: "rgba(255,255,255,0.85)",
              backdropFilter: "blur(2px)",
              boxShadow: "0 1px 9px rgba(0,0,0,0.15)",
              "&:hover": { backgroundColor: "#fff", transform: "scale(1.05)" },
            }}
            onClick={handleClickFavorite}
          >
            <FavoriteIcon
              className="responsive_fontsize24"
              sx={{ color: "#c65d38"}}
            />
          </IconButton>
        ) : null}

        <FoodCardContent
          fooditem={fooditem}
          subcategory={`${fooditem.item_subcategory} ${fooditem.item_type} ${fooditem.item_name}`}
          quantity={quantity}
          handleAddToCart={handleAddToCart}
          item_image={fooditem.item_image}
          image={imageUrl}
          item_price={price}
        />
      </Card>

      {openPopover && popoverID === fooditem.id && (
        <FavoritePopover
          open={openPopover}
          onClosePopover={handleClosePopover}
          foodItemToAdd={foodItemToAdd}
          fooditem={fooditem}
          anchorEl={anchorElRef.current} // <-- use ref instead of getElementById
          handleOpenMenuNameDialog={(event) =>
            handleOpenMenuNameDialog(event, fooditem)
          }
          menuName={selectedMenus.map((menu) => menu.menuName)}
          handleClose={handleClose}
          handleAddMenu={handleAddMenu}
          handleMenuClick={handleMenuClick}
          selectedMenus={selectedMenus}
          handleOpenDelete={handleOpenDelete}
          handleMenuDelete={handleMenuDelete}
          handleDeleteDialog={handleDeleteDialog}
          handleOpenMenuDeleteDialog={handleOpenMenuDeleteDialog}
          handleCloseMenuDeleteDialog={handleCloseMenuDeleteDialog}
          deleteMenuName={deleteMenuName}
          item_price={price}
          handleAddItemToExistingMenu={handleAddItemToExistingMenu}
        />
      )}

      {openMenuDialog && popoverID === fooditem.id && (
        <MenuDialogs
          openMenuNameDialog={openMenuDialog}
          handleCloseMenuNameDialog={handleCloseMenuNameDialog}
          menuName={menuName}
          setMenuName={(value) => dispatch(setMenuName(value))}
          confirmDeleteDialog={confirmDeleteDialog}
          setConfirmDeleteDialog={(state) =>
            state
              ? dispatch(openConfirmDeleteDialog())
              : dispatch(closeConfirmDeleteDialog())
          }
          deleteMenuName={menuName}
          confirmDelete={() => {}}
          handleInputChange={handleInputChange}
          handleClose={handleClose}
          handleSaveMenuName={handleSaveMenuName}
          fooditem={items}
        />
      )}
    </Box>
  );
}

FoodCard.propTypes = {
  fooditem: PropTypes.object.isRequired,
  quantity: PropTypes.number,
  handleIncrement: PropTypes.func,
  handleDecrement: PropTypes.func,
  menuName: PropTypes.string,
  confirmDeleteDialog: PropTypes.bool,
  handleClose: PropTypes.func,
  handleAddMenu: PropTypes.func,
  handleMenuClick: PropTypes.func,
  handleOpenDelete: PropTypes.func,
  handleMenuDelete: PropTypes.func,
  handleDeleteDialog: PropTypes.func,
  items: PropTypes.array,
  inMenu: PropTypes.bool,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  showFavorite: PropTypes.bool,
  fullWidth: PropTypes.bool,
  handleOpenPopover: PropTypes.func,
  handleClosePopover: PropTypes.func,
};

export default FoodCard;
